import { Phone, CalendarCheck, MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";
import { CLINIC, whatsappLink } from "../lib/constants";

export const MobileBar = () => (
  <div
    className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-white/95 backdrop-blur-md border-t border-slate-200 shadow-[0_-8px_30px_-12px_rgba(10,43,92,0.25)]"
    data-testid="mobile-action-bar"
  >
    <div className="grid grid-cols-3">
      <a
        href={CLINIC.phoneLink}
        className="flex flex-col items-center gap-1 py-2.5 text-ink active:bg-brand-mist"
        data-testid="mobile-bar-call"
        aria-label="Call iNetra now"
      >
        <Phone className="w-5 h-5" aria-hidden="true" />
        <span className="text-[10px] font-bold tracking-wide">CALL NOW</span>
      </a>
      <a
        href={whatsappLink("Hello iNetra, I would like to book an appointment.")}
        target="_blank"
        rel="noopener noreferrer"
        className="flex flex-col items-center gap-1 py-2.5 text-emerald-600 active:bg-emerald-50"
        data-testid="mobile-bar-whatsapp"
        aria-label="WhatsApp iNetra"
      >
        <MessageCircle className="w-5 h-5" aria-hidden="true" />
        <span className="text-[10px] font-bold tracking-wide">WHATSAPP</span>
      </a>
      <Link
        to="/contact#book"
        className="flex flex-col items-center justify-center gap-1 py-2.5 bg-ink text-white"
        data-testid="mobile-bar-book"
        aria-label="Book an appointment"
      >
        <CalendarCheck className="w-5 h-5" aria-hidden="true" />
        <span className="text-[10px] font-bold tracking-wide">BOOK</span>
      </Link>
    </div>
  </div>
);
